<template>
  <div id="app" :class="'lang_'+ lang + ' country_' + country" translate="no">
    <div class="page--transition"></div>
    <div class="preloader">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>



    <Header></Header>
    <PageWrapper v-if="lang != ''" :lang="lang" :id="id" :kapitel="kapitel"></PageWrapper>

  </div>
</template>

<script>
import Header from "@/components/partials/Header";
import Settings from "@/settings/settings.json";
import PageWrapper from "@/views/pages/PageWrapper";

export default {

  name: 'App',
  components: {
    Header,
    PageWrapper
  },
  data() {
    return {
      firstOpen: true,
      texte: Array,
      lang: "",
      country: "",
      id: "010",
      windowOrientation: null,
      windowWidth: 0,
      kapitel: "01",
      substitutes: {
        'red': '<span class="font-color-red">',
        '/red': '</span>',
        'quote': '"',
        'br': '<br>',
        'bold': '<strong>',
        '/bold': '</strong>',
        'italic': '<em>',
        '/italic': '</em>',
        'uppercase': '<span class="uppercase">',
        '/uppercase': '</span>',
        'small': '<small>',
        '/small': '</small>',
        'sup': '<sup>',
        '/sup': '</sup>',
        'nobreak': '<span class="nobr">',
        '/nobreak': '</span>',
        'span': '<span>',
        '/span': '</span>',
      }

    }
  },
  created: function () {
    let modulename = Settings["Modulname"];
    let c = Settings["Chapters"];

    let lang = Settings["StandardLanguage"];
    let country = Settings["StandardCountry"];
    let direction = 'ltr';
    let this_ = this;

    let environment = process.env.NODE_ENV;
    if(environment == "development"){
      this.$store.dispatch("enterModuleLocal", {module: modulename, lang: lang, chapters: c}).then(function () {
        this_.lang = this_.$store.getters.lang;
        this_.country = this_.$store.getters.country;

        if (this_.lang == 'ar' || this_.lang == 'AR') {
          this_.direction = 'rtl';
        } else {
          this_.direction = 'ltr';
        }
      });
    } else {

      this.$store.dispatch("enterModule", {module: modulename, lang: '', chapters: c}).then(function () {
        this_.lang = this_.$store.getters.lang;
        this_.country = this_.$store.getters.country;

        if (this_.lang == 'ar' || this_.lang == 'AR') {
          this_.direction = 'rtl';
        } else {
          this_.direction = 'ltr';
        }
      });
    }

    this.$store.watch(
        (state, getters) => getters.lang,
        (newValue, oldValue) => {
          this.lang = this.$store.getters.lang;
          if (this.lang == 'ar' || this.lang == 'AR') {
            this.direction = 'rtl';
          } else {
            this.direction = 'ltr';
          }
        }
    ),
        this.$store.watch(
            (state, getters) => getters.country,
            (newValue, oldValue) => {
              this.country = this.$store.getters.country;
            }
        )
  },
  methods: {
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight;
    },
    getOrientation(){
      console.log(this.windowWidth <= 900)
      console.log(this.windowWidth)
      let v = true;
      if(this.windowWidth <= 900){
        v = window.innerHeight > window.innerWidth;
      }
      this.windowOrientation = v;
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);
      window.addEventListener('resize', this.getOrientation);

      //Init
      this.getWindowWidth()
      this.getWindowHeight()
      this.getOrientation()

    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
    window.removeEventListener('resize', this.getOrientation);
  },
  computed:{

  },
  watch: {
    '$route.params.pageid': function (id) {
      this.pageid = id;
    },
    '$route.params.kapitel': function (kapitel) {
      this.kapitel = kapitel;
    }
  },

};
</script>